import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHero from "../components/PageHeader";
import { VESSELS, COMPANY, PAGE_HEROES } from "../data/site";

export default function BookNow() {
  const hero = PAGE_HEROES.book;
  return (
    <div data-testid="book-page" className="bg-[#f7f4ec]">
      <PageHero image={hero.image} title={hero.title} subtitle="Reserve your river day." testId="book-hero" />

      <section className="max-w-[1600px] mx-auto px-6 md:px-10 lg:px-14 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-14">
          <div className="md:col-span-7">
            <h2 className="font-serif text-3xl md:text-4xl text-[#13263c] leading-tight tracking-tight">
              Choose a vessel.
            </h2>
            <hr className="accent-rule mt-3" />
            <p className="mt-5 text-[#4a4a4a] max-w-xl">
              Rentals are built around a 24-hour rental window. Online reservations open soon — until then, reach us directly and we'll get you on the water.
            </p>
            <ul className="mt-8 border-t border-[#e3ddcf]">
              {VESSELS.map((v, i) => (
                <li
                  key={v.slug}
                  data-testid={`book-vessel-${v.slug}`}
                  className="border-b border-[#e3ddcf]"
                >
                  <Link
                    to={`/fleet/${v.slug}`}
                    className="grid grid-cols-12 gap-4 py-6 items-baseline group"
                  >
                    <span className="col-span-1 font-serif text-lg text-[#b8895a]">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <div className="col-span-7 md:col-span-8">
                      <h3 className="font-serif text-xl md:text-2xl text-[#13263c] group-hover:text-[#b8895a] transition-colors">
                        {v.shortName}
                      </h3>
                      <p className="text-[#737373] text-sm mt-1">{v.line}</p>
                    </div>
                    <span className="col-span-4 md:col-span-3 text-right text-[#13263c] font-medium">
                      {v.rate}
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <aside className="md:col-span-5">
            <div className="bg-[#13263c] text-[#f7f4ec] p-10 rounded-md">
              <p className="overline text-[#b8895a]">Reservations</p>
              <h2 className="font-serif text-3xl md:text-4xl text-[#f7f4ec] mt-4 leading-tight">
                Opening soon.
              </h2>
              <hr className="accent-rule mt-3" />
              <p className="text-[#d6d0c4] mt-5 leading-relaxed">
                The online reservation system is coming. To hold a date now, contact us directly and we'll confirm your vessel and 24-hour window.
              </p>
              <div className="mt-8 space-y-3">
                <a
                  href={COMPANY.phoneHref}
                  data-testid="book-phone-cta"
                  className="flex items-center justify-between border-b border-[#1f3a5a] py-3 hover:border-[#b8895a] hover:text-[#b8895a] transition-colors"
                >
                  <span className="overline text-[#b8895a]">Call</span>
                  <span className="font-serif text-2xl">{COMPANY.phone}</span>
                </a>
                <a
                  href={COMPANY.emailHref}
                  data-testid="book-email-cta"
                  className="flex items-center justify-between border-b border-[#1f3a5a] py-3 hover:border-[#b8895a] hover:text-[#b8895a] transition-colors"
                >
                  <span className="overline text-[#b8895a]">Email</span>
                  <span className="font-serif text-lg md:text-xl break-all text-right">
                    {COMPANY.email}
                  </span>
                </a>
              </div>
              <Link
                to="/contact"
                data-testid="book-contact-cta"
                className="mt-8 inline-flex items-center gap-2 text-[#b8895a] hover:text-[#f7f4ec] transition-colors"
              >
                Full contact details <ArrowRight size={14} />
              </Link>
            </div>
          </aside>
        </div>
      </section>
    </div>
  );
}
